function DragToScroll(el_container, change_cursor, clamp_x, clamp_y) {
	document.addEventListener('DOMContentLoaded', function() {
	    el_container.style.cursor = 'grab';

	    let pos = { top: 0, left: 0, x: 0, y: 0 };

	    const mouseDownHandler = function(e) {
	        if (change_cursor) el_container.style.cursor = 'grabbing';
	        el_container.style.userSelect = 'none';

	        pos = {
	            left: el_container.scrollLeft,
	            top: el_container.scrollTop,
	            // Get the current mouse position
	            x: e.clientX,
	            y: e.clientY,
	        };

	        document.addEventListener('mousemove', mouseMoveHandler);
	        document.addEventListener('mouseup', mouseUpHandler);
	    };

	    const mouseMoveHandler = function(e) {
	        // How far the mouse has been moved
	        const dx = e.clientX - pos.x;
	        const dy = e.clientY - pos.y;

	        // Scroll the element
	        if (!clamp_y) el_container.scrollTop = pos.top - dy;
	        if (!clamp_x) el_container.scrollLeft = pos.left - dx;
	    };

	    const mouseUpHandler = function() {
	        if (change_cursor) el_container.style.cursor = 'grab';
	        el_container.style.removeProperty('user-select');

	        document.removeEventListener('mousemove', mouseMoveHandler);
	        document.removeEventListener('mouseup', mouseUpHandler);
	    };

	    // Attach the handler
	    el_container.addEventListener('mousedown', mouseDownHandler);
		});
	return this;
}
